export const GET_STUDENTS = 'GetStudents';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_ROLES = 'GET_ALL_ROLES';
